// @flow
import * as R from "ramda"
import type { PriceType } from "@kiwicom/nitro/lib/records/Price"

import type { PriceTotal } from "mmb/types/primitiveTypes"

export type PriceParams = {
  amount: PriceTotal,
  base?: number,
  service?: number,
  serviceFlat?: number,
  merchant?: number,
  currency?: string,
}

const DEFAULT_CURRENCY = "eur"
const PRICE_COMPONENTS = ["amount", "base", "service", "serviceFlat", "merchant"]

export default class Price {
  amount: PriceTotal

  base: number

  service: number

  serviceFlat: number

  merchant: number

  currency: string

  constructor({ amount, base, currency, service, serviceFlat, merchant }: PriceParams) {
    if (!R.is(Number, amount)) {
      throw new Error("'amount' is not number")
    }

    this.amount = amount
    this.base = base || amount
    this.service = service || 0
    this.serviceFlat = serviceFlat || 0
    this.merchant = merchant || 0
    this.currency = currency ? currency.toLowerCase() : DEFAULT_CURRENCY
  }

  get ourService() {
    return this.service + this.serviceFlat
  }

  get totalService() {
    return this.ourService + this.merchant
  }

  static sum(input: Array<Price | PriceType>): Price {
    // eslint-disable-next-line prefer-rest-params
    const prices: Array<Price | PriceType> = Array.isArray(input) ? input : Array.from(arguments)
    const involvedCurrencies = R.pipe(
      R.pluck("currency"),
      R.uniq,
      // $FlowFixMe
    )(prices)

    if (involvedCurrencies.length > 1) {
      throw new Error("Unable sum prices with different currencies")
    }

    return new Price(
      // $FlowFixMe
      R.pipe(
        // $FlowFixMe
        R.map(x => [x, prices.reduce((acc, y) => acc + R.prop(x, y), 0)]),
        R.fromPairs,
        // $FlowFixMe
        R.assoc("currency", R.head(involvedCurrencies)),
      )(PRICE_COMPONENTS),
    )
  }

  static multiply(price: Price, multiplier: number) {
    return new Price({
      amount: price.amount * multiplier,
      base: price.base * multiplier,
      currency: price.currency,
      service: price.service * multiplier,
      serviceFlat: price.serviceFlat * multiplier,
      merchant: price.merchant * multiplier,
    })
  }
}
